<template>
  <v-card class="elevation-12 mt-3 mx-1" :loading="loading">
    <v-toolbar color="primary" dark flat>
      <template v-if="isPostPackageLoaded">
        Пост пакет: {{ postPackage.uid }}
        <span class="mx-5">|</span>
        Дата создания: {{ postPackage.createdOn.format('DD.MM.YYYY HH:mm:ss') }}
        <span class="mx-5">|</span>
        Создан: {{ postPackage.account.name }}
        <span class="mx-5">|</span>
        Пост-индекс: {{ postPackage.postCode }}

        <template v-if="postPackage.postIndex">
          {{ postPackage.postIndex.name }}
        </template>
      </template>

      <v-spacer/>

      <template v-if="isPostPackageLoaded">
        <v-btn v-if="isAllowChangePostPackageIndex" @click="editPostCodeDialog = true" small color="warning">
          Редактирование пост-индекса

          <v-icon class="ml-1">mdi-pencil</v-icon>
        </v-btn>

        <v-dialog v-model="editPostCodeDialog" max-width="600px">
          <ChangePostPackagePostCode :post-package="postPackage" ref="changePostPackagePostCode"
                                     @close="editPostCodeDialog = false"/>
        </v-dialog>
      </template>
    </v-toolbar>

    <v-card-text v-if="isPostPackageLoaded">
      <v-simple-table dense>
        <template v-slot:default>
          <thead>
          <tr>
            <th>№</th>
            <th>Идентификатор</th>
            <th>Получатель</th>
            <th>Область</th>
            <th>Район</th>
            <th>Адрес</th>
            <th>Дата поступления</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="mail in displayMails" :key="mail.id"
              :class="{
                    'white--text black': mail.isPerformedNotTry,
                    'white--text warning darken-1': mail.isPerformedTry,
                    'green lighten-4': !mail.isPerformedNotTry && mail.isPacked,
                    'light-blue lighten-4': !mail.isPerformedNotTry && !mail.isPacked && mail.isPrinted,
                    }">
            <td>{{ mail.displayNumber }}</td>
            <td>
              <router-link :to="{name: 'mail', params:{uid: mail.uid}}">
                {{ mail.uid }}
              </router-link>
            </td>
            <td>{{ mail.receiver }}</td>
            <td>{{ mail.region.name }}</td>
            <td>{{ mail.area.name }}</td>
            <td>{{ mail.address }}</td>
            <td class="text-center">
              {{ mail.createdOn.format('DD.MM.YYYY') }}
              <br>
              {{ mail.createdOn.format('HH:mm:ss') }}
            </td>
            <td class="text-right" style="width: 600px;">
<!--              <v-btn color="default" class="ml-1" x-small v-if="mail.allowTryPerform"-->
<!--                     @click="activeMail = mail; tryPerformDialog = true">Попытка вручения-->
<!--              </v-btn>-->

              <v-btn color="success" class="ml-1 my-1" x-small v-if="mail.allowDeliveryPerform"
                     @click="loadHistories(mail); deliveredDialog = true">
                Вручено(Топширилди)
              </v-btn>

              <v-btn color="error" class="ml-1 my-1" x-small v-if="mail.allowFailedPerform"
                     @click="loadHistories(mail); failedDialog = true">
                Возврат(Қайтариш)
              </v-btn>

              <v-btn color="error" class="ml-1 my-1" x-small v-if="mail.allowUnsetPostPackage && isAllowUnsetPostPackageMail && !mail.postPackage.uid.startsWith('XPSL')"
                     @click="loadHistories(mail); unsetPostPackageDialog = true">Досыл(Бошқа манзилга юбориш)
              </v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <span>Писем: {{ mailsCount }}</span>
      <span class="ml-3">Листов: {{ mailsPagesSum }}</span>
      <v-spacer/>
      <v-btn color="warning" small @click="onReprintButtonClicked">Распечатать ещё раз</v-btn>
    </v-card-actions>
    <v-snackbar v-model="isMailsLoadingFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось загрузить письма
    </v-snackbar>
    <v-snackbar v-model="isPostPackageLoadingFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось загрузить пост пакет
    </v-snackbar>

    <template v-if="activeMail">
      <v-dialog v-model="tryPerformDialog" max-width="600px" :persistent="true">
        <TryPerform :mail-history="histories" :mail="activeMail" @close="tryPerformDialog = false"/>
      </v-dialog>

      <v-dialog v-model="deliveredDialog" max-width="600px" :persistent="true">
        <SuccessDeliveredPerform :mail-history="histories" :mail="activeMail" @close="deliveredDialog = false"/>
      </v-dialog>

      <v-dialog v-model="failedDialog" max-width="800px" :persistent="true">
        <FailedDeliveryPerform :mail-history="histories" :mail="activeMail" @close="failedDialog = false"/>
      </v-dialog>

      <v-dialog v-model="unsetPostPackageDialog" max-width="600px" :persistent="true">
        <MailUnsetPostPackage :mail="activeMail" @close="unsetPostPackageDialog = false"/>
      </v-dialog>
    </template>
  </v-card>
</template>

<script>
import _ from "underscore";
import {
  LAYOUT_LOADING_START,
  LAYOUT_LOADING_STOP,
  LAYOUT_TITLE_CHANGED
} from "@/store/modules/layout/actions";
import PostPackageService from "@/services/post.package.service";
import Mappers from "@/mappers";
import PrintJS from "print-js";
import TryPerform from '@/components/mail/perform/TryPerform'
import FailedDeliveryPerform from '@/components/mail/perform/FailedDeliveryPerform'
import SuccessDeliveredPerform from '@/components/mail/perform/SuccessDeliveredPerform'
import MailUnsetPostPackage from '@/components/mail/MailUnsetPostPackage'
import ChangePostPackagePostCode from '@/components/ChangePostPackagePostCode'
import * as AppEvents from "@/events/app";
import {AllowChangePostPackageIndex, AllowDeleteFromPostPackage} from "@/enums/permission";
import MailService from "@/services/mail.service";

export default {
  name: "PostPackageView",
  components: {
    TryPerform,
    FailedDeliveryPerform,
    SuccessDeliveredPerform,
    MailUnsetPostPackage,

    ChangePostPackagePostCode
  },
  data() {
    return {
      // datatable
      postPackage: null,
      mails: [],
      histories: [],
      loading: false,
      isMailsLoadingFailed: false,
      isPostPackageLoadingFailed: false,

      // performs and unset
      deliveredDialog: false,
      failedDialog: false,
      tryPerformDialog: false,
      unsetPostPackageDialog: false,
      activeMail: null,

      // edit post code
      editPostCodeDialog: false
    }
  },
  computed: {
    pageTitle() {
      let title = 'Пост пакет'
      if (this.postPackage)
        title = `${title} : ${this.postPackage.uid}`

      return title
    },
    isPostPackageLoaded() {
      return !!this.postPackage
    },
    mailsCount() {
      return this.mails.length
    },
    mailsPagesSum() {
      let sum = 0
      _.each(this.mails, m => {
        sum += m.pagesCount
      })

      return sum
    },
    displayMails() {
      let number = 1;
      return _.map(this.mails, m => {
        m.displayNumber = number++

        return m
      })
    },
    isAllowChangePostPackageIndex() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowChangePostPackageIndex
      })
    },
    isAllowUnsetPostPackageMail() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowDeleteFromPostPackage
      })
    },
  },
  methods: {
    loadPostPackage() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      this.postPackage = null
      const uid = this.$route.params.uid

      this.isPostPackageLoadingFailed = false
      PostPackageService.get(uid)
          .then(response => {
            this.postPackage = Mappers.mapPostPackage(response.data)
            this.setPageTitle()

            this.loadMails()
          })
          .catch(() => {
            this.isPostPackageLoadingFailed = true
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadMails() {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)
      this.isMailsLoadingFailed = false

      PostPackageService.getMails(this.postPackage.uid)
          .then(response => {
            this.mails = _.map(response.data, mailViewModel => {
              return Mappers.mapMail(mailViewModel)
            })
          })
          .catch(() => {
            this.isMailsLoadingFailed = true
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadHistories(mail) {
      this.activeMail = mail
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      MailService.getHistories(mail.uid)
          .then(response => {
            this.histories = _.map(response.data, mailHistoryViewModel => {
              return Mappers.mapMailHistory(mailHistoryViewModel)
            })
          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    setPageTitle() {
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.pageTitle)
    },

    onReprintButtonClicked() {
      const path = PostPackageService.getPdfPath(this.postPackage)

      PrintJS({
        printable: path,
        type: 'pdf',
        showModal: true,
        modalMessage: 'Подождите, идет загрузка для печати'
      })
    },

    onMailPerformed() {
      this.deliveredDialog = false
      this.failedDialog = false
      this.tryPerformDialog = false
      this.unsetPostPackageDialog = false

      this.activeMail = null
      this.loadMails()
    },
    onUnsetPostPackage() {
      this.deliveredDialog = false
      this.failedDialog = false
      this.tryPerformDialog = false
      this.unsetPostPackageDialog = false

      this.activeMail = null
      this.loadMails()
    },

    onChangePostPackagePostCode(payload) {
      const {postPackage, postCode} = payload

      if (this.postPackage && this.postPackage.uid === postPackage.uid)
        this.postPackage.postCode = postCode

      this.editPostCodeDialog = false
    }
  },
  created() {
    this.setPageTitle()
    this.loadPostPackage()

    this.$bus.$on(AppEvents.APP_MAIL_PERFORMED, this.onMailPerformed)
    this.$bus.$on(AppEvents.APP_MAIL_UNSET_POST_PACKAGE, this.onUnsetPostPackage)
    this.$bus.$on(AppEvents.APP_POST_PACKAGE_POST_CODE_CHANGED, this.onChangePostPackagePostCode)
  },
  beforeDestroy() {
    this.$bus.$off(AppEvents.APP_MAIL_PERFORMED, this.onMailPerformed)
    this.$bus.$off(AppEvents.APP_MAIL_UNSET_POST_PACKAGE, this.onUnsetPostPackage)
    this.$bus.$off(AppEvents.APP_POST_PACKAGE_POST_CODE_CHANGED, this.onChangePostPackagePostCode)
  },
  watch: {
    "$route": function () {
      this.loadPostPackage()
    }
  },
}
</script>

<style scoped>
.white--text a {
  color: #ffffff;
  text-decoration: none;
}
</style>
